// types
import { ICampus } from './types'

// components
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper'
// api
import { useStyletron } from 'baseui';
import { Icon } from './Icon';
import { useGetRelationsOutByIdQuery } from '../../../../services/objects';
import { GoogleMap } from '../../../../components/Map';
import { TMarker } from '../../../../components/Map/Map';
import { IAutomationObject } from '../../../types';
import { schema as schemaBuilding } from '../../../Plants/Buildings/P_Building'
import ActiveLightsPanel from '../../../Devices/Light/ActiveLightsPanel';
import { ActiveAirHandlingUnits } from '../../../Plants/AirHandlingUnits/P_AirHandlingUnit';
import { ActiveCoolingGenerators } from '../../../Plants/Coolings/P_CoolingGenerator';
import { ActiveCoolingOutlets } from '../../../Plants/Coolings/P_CoolingOutlet';
import { ActiveHeatingGenerators } from '../../../Plants/Heatings/P_HeatingGenerator';
import { ActiveHeatingCoolingOutlets } from '../../../Plants/HeatingCoolings/P_HeatingCoolingOutlet';
import { ActiveHeatingPuffer } from '../../../Plants/Heatings/P_HeatingPuffer';
import { ActiveHeatingOutlets } from '../../../Plants/Heatings/P_HeatingOutlet';
import { ImportantAlarms} from '../../../Plants/Buildings/P_Building'
import { themedUseStyletron } from '../../../../theme/customTheme';


export function OverviewPanel(props: ICampus) {
    const [, theme] = themedUseStyletron();

    const { data, isLoading, error, isSuccess } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: 'Contains' })

    const mapItems: TMarker[] = data?.filter((item: IAutomationObject) => item.schema ===  schemaBuilding).map((item: any) => { return { title: item.description, longitude: item.address.longitude, latitude: item.address.latitude } }) ?? [];
    return (
        <OverviewPanelWrapper height={theme.appSizes.largeAppHeight} icon={<Icon size='100%' color={theme.colors.backgroundPrimary}></Icon>} {...props}>
            <GoogleMap width={'100%'} height={'200px'} markers={mapItems}   ></GoogleMap>
            <ImportantAlarms {...props}></ImportantAlarms>
            <ActiveAirHandlingUnits parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveAirHandlingUnits>
            <ActiveHeatingGenerators parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveHeatingGenerators>
            <ActiveHeatingOutlets parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveHeatingOutlets>
            <ActiveCoolingGenerators parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveCoolingGenerators>
            <ActiveCoolingOutlets  parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveCoolingOutlets>
            <ActiveHeatingPuffer  parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveHeatingPuffer>
            <ActiveLightsPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></ActiveLightsPanel>
        </OverviewPanelWrapper>
    );
}

